import { createContext, useContext, useEffect, useState, useRef } from 'react';
import useLoadingProducts from '../Components/useLoadingProducts';
import useHandleCategories from '../Pages/Shop/Hooks/useHandleCategories';
import { useAuth } from './AuthProvider';
import useGetSuppliers from '../Pages/Shop/Hooks/useGetSuppliers';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ShopContext = createContext()

export const useShop = () => {
    return useContext(ShopContext)
}

export const ShopProvider = ({ children }) => {
    const navigate = useNavigate()
    const { authState } = useAuth()
    const [activeCategory, setActiveCategory] = useState(null)
    const [features, setFeatures] = useState([])
    const [pageNumber, setPageNumber] = useState(0)
    const [productIndex, setProductIndex] = useState(0)
    const { suppliers, handleGetSuppliers } = useGetSuppliers()

    const [productsFilter, setProductsFilter] = useState({
        ProductsFeatures: features,
        AvailabilityFilters: {
            OnlyLocal: false,
            OnlyRegional: false,
            OnlyMacroRegional: false,
            OnlySupplier: false,
        },
        IsNew: false,
        IsPromo: false,
        IsSellOut: false,
        PriceFrom: 0,
        PriceTo: 0,
        ActiveCatNodeId: activeCategory ? activeCategory.nodeId : 0,
        ArtCatOrSymbolList: [],
        ArtNo: String(productIndex),
        CustId: authState.custId,
        SearchingQuery: '',
        SiteId: authState.siteId ? authState.siteId : '',
        WhId: authState.whId ? authState.whId : '',
        AllArticles: false,
        Suppliers: [],
        SortType: 0,
    })

    useEffect(() => {
        const source = axios.CancelToken.source()
        handleGetSuppliers(productsFilter, source.token)
        return () => {
            source.cancel()
        }
    }, [JSON.stringify(productsFilter)])

    const { categoriesForHomePage, categoryData, isLoadingCategoriesForHomePage, rootCategories, isLoadingRootCategories, isLoadingCategoryData }
        = useHandleCategories(activeCategory, productsFilter)

    const [showFeatureListFilter, setShowFeatureListFilter] = useState(true)
    const [downloadCategoriesAfterQuerySearching, setDownloadCategoriesAfterQuerySearching] = useState(false)

    const clearProductsFilter = (saveActiveCategory, navigateToProductList) => {
        const tmpActiveCatNodeId = activeCategory ? activeCategory.nodeId : 0
        setProductsFilter({
            ProductsFeatures: [],
            AvailabilityFilters: {
                OnlyLocal: false,
                OnlyRegional: false,
                OnlyMacroRegional: false,
            },
            IsNew: false,
            IsPromo: false,
            IsSellOut: false,
            PriceFrom: 0,
            PriceTo: 0,
            ActiveCatNodeId: saveActiveCategory ? tmpActiveCatNodeId : 0,
            ArtCatOrSymbolList: [],
            ArtNo: "0",
            CustId: authState.custId,
            SiteId: authState.siteId ? authState.siteId : '',
            WhId: authState.whId ? authState.whId : '',
            AllArticles: false,
            Suppliers: [],
            SortType: 0,
        })
        setFeatures([])
        if (!saveActiveCategory) {
            setActiveCategory(null)
            localStorage.setItem("categoryNavigationTree", JSON.stringify(null))
        }
        if (navigateToProductList) {
            navigate('/shop')
        }
    }

    useEffect(() => {
        if (productsFilter.SearchingQuery) {
            setShowFeatureListFilter(true)
        }
    }, [productsFilter.SearchingQuery])

    useEffect(() => {
        setProductsFilter(prev => ({ ...prev, CustId: authState.custId }))
    }, [authState.custId])

    useEffect(() => {
        setProductsFilter(prev => ({ ...prev, ArtNo: String(productIndex) }))
    }, [productIndex])

    useEffect(() => {
        setProductsFilter(prev => ({ ...prev, ActiveCatNodeId: activeCategory ? activeCategory.nodeId : 0 }))
    }, [activeCategory])

    useEffect(() => {
        setProductsFilter(prev => ({ ...prev, ProductsFeatures: features }))
    }, [features])

    // Centralny mechanizm resetujący paginacje
    const prevFilterRef = useRef()
    useEffect(() => {
        const prevFilterString = prevFilterRef.current
        const currentFilterString = JSON.stringify(productsFilter)

        //Resetuj numer strony, jeśli filtry się zmieniły.
        if (prevFilterString && prevFilterString !== currentFilterString) {
            setPageNumber(0)
        }
        // Zapisz aktualny stan filtra do porównania w następnym cyklu.
        prevFilterRef.current = currentFilterString
    }, [productsFilter])


    const {
        products,
        hasMore,
        loadingProducts,
        productsFeatures,
        handleGetProductsFromSearchingBar,
        setProducts
    } = useLoadingProducts(pageNumber, setPageNumber, productsFilter, setProductsFilter, activeCategory)

    return (
        <ShopContext.Provider value={{
            products,
            loadingProducts,
            hasMore,
            activeCategory,
            categoriesForHomePage,
            categoryData,
            isLoadingCategoriesForHomePage,
            productsFeatures,
            features,
            showFeatureListFilter,
            downloadCategoriesAfterQuerySearching,
            productsFilter,
            rootCategories,
            isLoadingRootCategories,
            suppliers,
            isLoadingCategoryData,
            setProducts,
            setPageNumber,
            clearProductsFilter,
            setProductsFilter,
            setDownloadCategoriesAfterQuerySearching,
            setShowFeatureListFilter,
            handleGetProductsFromSearchingBar,
            setFeatures,
            setActiveCategory,
        }}>
            {children}
        </ShopContext.Provider>
    )
}